import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { default as MenuItem } from '../../../../components/Menu/MenuItem';
import { underlinedItem } from '../../../teams/components/Menu/menuItemStyles';
import submenuIndicatorUrl from '../../../teams/components/Menu/submenuIndicatorUrl';
var menuItemStyles = {
  wrapper: function wrapper(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    var iconOnly = p.iconOnly,
        isFromKeyboard = p.isFromKeyboard,
        vertical = p.vertical,
        active = p.active,
        underlined = p.underlined,
        primary = p.primary,
        pointing = p.pointing,
        disabled = p.disabled;
    return Object.assign({
      ':hover': Object.assign({
        color: v.colorActive
      }, !active && Object.assign({}, primary && !underlined && {
        color: v.colorActive
      }, {
        background: v.backgroundColorFocus
      }), _defineProperty({}, "&>.".concat(MenuItem.className, ">.").concat(MenuItem.slotClassNames.indicator), {
        backgroundImage: submenuIndicatorUrl(v.colorActive, p.vertical)
      }))
    }, active && !underlined && _defineProperty({
      background: v.backgroundColorActive,
      color: v.colorActive
    }, "&>.".concat(MenuItem.className, ">.").concat(MenuItem.slotClassNames.indicator), {
      backgroundImage: submenuIndicatorUrl(v.colorActive, p.vertical)
    }), {}, (iconOnly || vertical) && Object.assign({}, isFromKeyboard && _defineProperty({
      color: v.colorActive,
      background: v.backgroundColorFocus
    }, "&>.".concat(MenuItem.className, ">.").concat(MenuItem.slotClassNames.indicator), {
      backgroundImage: submenuIndicatorUrl(v.colorActive, p.vertical)
    }), {}, active && _defineProperty({
      color: v.colorActive,
      background: v.backgroundColorActive
    }, "&>.".concat(MenuItem.className, ">.").concat(MenuItem.slotClassNames.indicator), {
      backgroundImage: submenuIndicatorUrl(v.colorActive, p.vertical)
    }), {
      ':hover': _defineProperty({
        color: v.colorActive,
        background: v.backgroundColorFocus
      }, "&>.".concat(MenuItem.className, ">.").concat(MenuItem.slotClassNames.indicator), {
        backgroundImage: submenuIndicatorUrl(v.colorActive, p.vertical)
      })
    }), {}, underlined && Object.assign({}, active && {
      color: v.color
    }, {
      ':hover': {
        color: v.color
      }
    }, isFromKeyboard && {
      color: v.colorActive
    }), {}, pointing && vertical && {
      '::before': {
        display: 'none'
      }
    }, {}, disabled && {
      cursor: 'default',
      ':hover': {// reset all existing hover styles
      }
    });
  },
  root: function root(_ref5) {
    var props = _ref5.props,
        v = _ref5.variables;
    var iconOnly = props.iconOnly,
        isFromKeyboard = props.isFromKeyboard,
        underlined = props.underlined,
        primary = props.primary,
        active = props.active;
    return Object.assign({}, underlined && Object.assign({}, active && Object.assign({
      color: v.color
    }, !primary && underlinedItem(v.color)), {
      ':hover': {
        color: v.color
      }
    }, isFromKeyboard && {
      color: v.colorActive
    }), {}, isFromKeyboard && iconOnly && {
      borderColor: 'transparent'
    });
  }
};
export default menuItemStyles;